export default __webpack_public_path__ + "static/media/icon-app-coopeuch.a177a021.png";